<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M13.8,21.9l0.2,0.2l0.2-0.2c7.2-6.5,12-10.8,12-15.2c0-3-2.3-5.3-5.3-5.3c-2.3,0-4.6,1.5-5.4,3.6h-2.8
	c-0.8-2.1-3.1-3.6-5.4-3.6c-3,0-5.3,2.3-5.3,5.3C1.9,11.1,6.6,15.4,13.8,21.9z" fill="#071689"/>
        <path d="M0.7,7.3c0,5,4.5,9.1,11.4,15.4l1.9,1.7l1.9-1.8c6.9-6.2,11.4-10.3,11.4-15.4C27.3,3.2,24.1,0,20,0
	c-2.3,0-4.5,1.1-6,2.8C12.5,1.1,10.3,0,8,0C3.9,0,0.7,3.2,0.7,7.3z M8,2.7c2.1,0,4.1,1.3,4.8,3.1h2.5C15.9,4,17.9,2.7,20,2.7
	c2.7,0,4.7,2,4.7,4.7c0,3.9-4.2,7.7-10.5,13.4L14,20.9l-0.1-0.1C7.5,15,3.3,11.2,3.3,7.3C3.3,4.7,5.3,2.7,8,2.7z" fill="#071689"/>
    </svg>
</template>

<script>
export default {
    name: "FavoriteIcon",

    props: {
        width: {
            type: Number,
            default: 28
        },

        height: {
            type: Number,
            default: 25
        },

        classes: {
            type: String
        }
    }
}
</script>